import { formToObject, invokeJsonEncoding, invokeMultipartEncoding, isSafari } from '../js-utils/_shared/form-utils';

interface Props {
    apiUrl?: string;
    isMultipartEncoding?: boolean;
    redirectUrl?: string;
    openInNewTab?: boolean;
    clientRecaptcha?: string;
    isLoginModel?: boolean;
    requiredFields?: string[];
    requiredFieldsMessage?: string;
}

export default function init(
    container: HTMLElement,
    {
        apiUrl,
        isMultipartEncoding,
        redirectUrl,
        openInNewTab,
        clientRecaptcha,
        isLoginModel,
        requiredFields,
        requiredFieldsMessage,
    }: Props,
) {
    const grecaptcha = clientRecaptcha == 'v2' ? (window as any).grecaptcha : null;
    const formElement = container.querySelector('form') as HTMLFormElement;
    if (!formElement || !apiUrl) {
        return;
    }
    let successPHolder: HTMLElement | null = null;
    let successShow: HTMLElement | null = null;
    let successHide: HTMLElement | null = null;
    if (!redirectUrl) {
        successPHolder = container.querySelector('.js-success-pholder') as HTMLElement;
        successHide = container.querySelector('.js-success-hide') as HTMLElement;
        successShow = container.querySelector('.js-success-show') as HTMLElement;
    }

    const failurePHolder = container.querySelector('.js-failure-pholder') as HTMLElement;
    const failureHide = container.querySelector('.js-failure-hide') as HTMLElement;
    const failureShow = container.querySelector('.js-failure-show') as HTMLElement;

    const processingHide = container.querySelector('.js-processing-hide') as HTMLElement;
    const processingShow = container.querySelector('.js-processing-show') as HTMLElement;

    const callApi = async () => {
        let errorMsg = '';
        let successMsg = '';
        let queryString = '';
        // call the API with a generic signature
        try {
            const formObj = formToObject(formElement!);
            if (isLoginModel) {
                formObj['loginModel.TipoDoc'] = (formObj['loginModel.TipoDoc'] as string)?.toUpperCase().trim() || '';
                formObj['loginModel.NroDoc'] =
                    (formObj['loginModel.NroDoc'] as string)?.replace('.', '').toUpperCase().trim() || '';
                formObj.username = `${formObj['loginModel.TipoDoc']}-${formObj['loginModel.NroDoc']}`;
                formObj['loginModel.Username'] = formObj.username;
            }
            // extraTasksBeforeSubmit(formObj);
            const response = isMultipartEncoding
                ? await invokeMultipartEncoding(formObj, apiUrl!)
                : await invokeJsonEncoding(formObj, apiUrl!);
            if (response.error) {
                const errors = (<any>response.error).errors ? Object.values((<any>response.error).errors) : [];
                errorMsg =
                    errors.length > 0 && Array.isArray(errors[0]) && errors[0].length
                        ? errors[0][0]
                        : 'Error no identificado. Verifique los datos o reintente más tarde';
            } else if (response.data?.status) {
                errorMsg = response.data.message;
            } else {
                successMsg = response.data?.message || '';
                queryString = (<any>response.data)?.value || '';
            }
        } catch (error) {
            errorMsg = error?.toString() || 'Error interno';
        }
        return { errorMsg, successMsg, queryString };
    };

    const handleSubmit = async (e: Event) => {
        e.preventDefault();
        let errorMsg = '';
        let successMsg = '';
        let queryString = '';

        if (requiredFields && requiredFields.length) {
            requiredFields.forEach((fieldName) => {
                const field = formElement.querySelector(`[name="${fieldName}"]`) as HTMLInputElement;
                const label = formElement.querySelector(
                    `[for="${fieldName}"],[for="search-${fieldName}"]`,
                ) as HTMLLabelElement;
                if (field && !field.value.trim()) {
                    // before flagging as required, make sure it is not a SELECT without any actual options
                    const select = field as unknown as HTMLSelectElement;
                    if (
                        !select.options ||
                        Array.from(select.options).find((option: HTMLOptionElement) => option.value)
                    ) {
                        errorMsg = requiredFieldsMessage || 'Por favor complete los campos requeridos';
                        if (label) {
                            label.style.color = '#e20178';
                        }
                    }
                } else {
                    if (label) {
                        label.style.color = '';
                    }
                }
            });
        }

        if (errorMsg) {
            if (failurePHolder) {
                failurePHolder.innerHTML = errorMsg;
                failurePHolder.style.display = 'inline-block';
            }
        } else {
            // prepare UI for processing state and call the API
            if (failurePHolder) {
                failurePHolder.style.display = 'none';
            }
            if (failureShow) {
                failureShow.style.display = 'none';
            }
            if (successPHolder) {
                successPHolder.style.display = 'none';
            }
            if (successShow) {
                successShow.style.display = 'none';
            }
            if (processingHide) {
                processingHide.style.display = 'none';
            }
            if (processingShow) {
                processingShow.style.display = 'flex';
            }

            if (clientRecaptcha == 'v2') {
                try {
                    const response = grecaptcha.getResponse();
                    if (!response?.length) {
                        errorMsg = 'El captcha es requerido';
                    }
                } catch {
                    errorMsg = 'Respuesta inválida del captcha';
                }
            }

            const resp = await callApi();
            errorMsg = resp.errorMsg;
            successMsg = resp.successMsg;
            queryString = resp.queryString;

            if (processingShow) {
                processingShow.style.display = 'none';
            }

            if (!errorMsg) {
                if (successHide) {
                    successHide.style.display = 'none';
                }
                if (successPHolder) {
                    successPHolder.innerText = successMsg!;
                    successPHolder.style.display = 'inline-block';
                }
                if (successShow) {
                    successShow.style.display = 'flex';
                    successShow.scrollIntoView({
                        behavior: 'auto',
                        block: 'center', // or 'center', 'end', 'nearest'
                    });
                }
                if (processingHide) {
                    processingHide.style.display = 'flex';
                }
                if (redirectUrl) {
                    if (openInNewTab && !isSafari()) {
                        var url = redirectUrl + queryString;
                        setTimeout(function () {
                            const newTab = window.open(url, '_blank');
                            // Check if the new tab was successfully opened and then focus it
                            if (newTab) {
                                newTab.focus();
                            }
                        }, 0);
                    } else {
                        window.location.assign(redirectUrl + queryString);
                    }
                }
            } else {
                if (failureHide) {
                    failureHide.style.display = 'none';
                }
                if (failurePHolder) {
                    failurePHolder.innerHTML = errorMsg;
                    failurePHolder.style.display = 'inline-block';
                }
                if (failureShow) {
                    failureShow.style.display = 'flex';
                }
                if (processingHide) {
                    processingHide.style.display = 'flex';
                }
            }
        }
        if (grecaptcha) {
            grecaptcha.reset();
        }
    };

    formElement.addEventListener('submit', handleSubmit);
}
